import { Component, Input, OnInit } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
import { Blog, Pages } from '../../../models/blog.model';
import { BlogService } from '../../../services/blog.service';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-blog-swiper',
  templateUrl: './blog-swiper.component.html',
  styleUrls: ['./blog-swiper.component.scss'],
})
export class BlogSwiperComponent implements OnInit {
  @Input() customHeader
  @Input() customClassName
  @Input() page = Pages.Home
  @Input() lang = 'th'
  blogs: Blog[] = []

  public currentSlide = 1

  transportPercentNo = 0

  // public blogs = [
  //   {
  //     subtitle: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.SUB_TITLE',
  //     heading: '1xxxxxxxxxxxxxxxxxxxxxxx',
  //     titleMobile: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.TITLE_MOBILE',
  //     coverUrlWebp:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.webp',
  //     coverUrlJpg:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.png',
  //     imageTitle: 'djedI6J5wzE',
  //     link: 'https://auth.flowaccount.com/',
  //   },
  //   {
  //     subtitle: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.SUB_TITLE',
  //     heading: '2xxxxxxxxxxxxxxxxxxxxxxx',
  //     titleMobile: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.TITLE_MOBILE',
  //     coverUrlWebp:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.webp',
  //     coverUrlJpg:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.png',
  //     imageTitle: 'djedI6J5wzE',
  //     link: 'https://auth.flowaccount.com/',
  //   },
  //   {
  //     subtitle: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.SUB_TITLE',
  //     heading: '3xxxxxxxxxxxxxxxxxxxxxxx',
  //     titleMobile: 'HOMEPAGE.NEW_FUNCTION_UPDATE.LIST.1.TITLE_MOBILE',
  //     coverUrlWebp:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.webp',
  //     coverUrlJpg:
  //       'https://flowaccountcdn.com/new_landing/image/home/function_update_section/function_update_q2_slide1_v1.png',
  //     imageTitle: 'djedI6J5wzE',
  //     link: 'https://auth.flowaccount.com/',
  //   }
  // ]

  public disabledNextActionClick = false
  public disabledPrevActionClick = false

  public limitClickRight = 1
  public limitClickLeft = 1

  // for detect dot and number for click prev and next
  public totalClickLength

  public desktopScreen = 1100

  constructor(
    public translate: TranslateService,
    public sharedService: SharedService,
    private blogService: BlogService,
  ) {}

  ngOnInit(): void {
    this.blogs = this.blogService.getBlogSwiperContents(this.lang, this.page)
    this.disabledPrevActionClick = true
    this.checkDefaultClickByDeviceScreen()
  }

  actionTransformNextSlide() {
    this.transportPercentNo -= 350
    const itemMoreThan3 = this.blogs.length > 3 ? 2 : 1

    if (this.limitClickRight == this.totalClickLength && this.limitClickLeft == this.totalClickLength) {
      this.disabledNextActionClick = true
    }
    this.limitClickRight++
    this.limitClickLeft = this.limitClickRight
    if (this.limitClickLeft != itemMoreThan3) {
      this.disabledPrevActionClick = false
    }

  }
  actionTransformPreviousSlide() {
    this.transportPercentNo += 350

    if (this.limitClickLeft == 2 && this.limitClickRight == 2) {
      this.disabledPrevActionClick = true
    } 
    if (this.limitClickRight != this.totalClickLength ) {
      this.disabledNextActionClick = false
    }
    this.limitClickLeft--
    this.limitClickRight = this.limitClickLeft
  }
  checkDefaultClickByDeviceScreen() {
    window.innerWidth >= this.desktopScreen
      ? (this.totalClickLength = this.blogs.length - 2)
      : (this.totalClickLength = this.blogs.length - 1)
  }
  onResize(event) {
    // console.log('event.target.innerWidth >>', event.target.innerWidth)
    // ถ้าเป็น desktopStyle screen จะ >= 1100px จำนวน click ปุ่ม prev และ next
    // จะเท่ากับ  this.functionList.length - 2 เพื่อความสวยงาม แต่ถ้าเป็น tablet และ mobile จะแสดงเป็น this.functionList.length - 1
    const checkScreen = event.target.innerWidth >= this.desktopScreen ? true : false
    checkScreen ? (this.totalClickLength = this.blogs.length - 2) : (this.totalClickLength = this.blogs.length - 1)
  }

  headingText(): string {
    return this.lang === 'th' ? 'บทความดีๆ เพื่อเจ้าของธุรกิจ' : 'Accounting basics for small businesses'
  }
  detailText(): string {
    return this.lang === 'th'
      ? 'ฝึกทำธุรกิจไปทีละก้าว ด้วยเทคนิคการทำเอกสารบัญชี และภาษีเบื้องต้นให้เจ้าของกิจการได้นำไปปรับใช้ในการทำงานสร้างธุรกิจได้อย่างมั่นคง'
      : 'Learn basic accounting and taxes for small businesses. Apply them right away. Establish firm footing so your business can grow to its full potential.'
  }

  readMore(): string {
    const lang = this.translate.currentLang
    return lang === 'th' ? 'อ่านเพิ่มเติม' : 'Read more'
  }

  // custom title
  displayCustomText(textObject, textPosition) {
    const { headingTH, headingEN, subHeadingTH, subHeadingEN, detailTH, detailEN } = textObject

    switch (textPosition) {
      case 'sub-heading':
        return this.lang === 'th' ? subHeadingTH : subHeadingEN
        break
      case 'heading':
        return this.lang === 'th' ? headingTH : headingEN
        break
      case 'detail':
        return this.lang === 'th' ? detailTH : detailEN
        break
    }
  }
}
